namespace GeniuzPOS.AdvPromo {
    export class Report_Adv01Columns {
        static columnsKey = 'AdvPromo.Report_Adv01';
    }
}
